import { ContentManagerService } from 'core/common/services';
import { isObject } from 'core/common/utils/isObject';

const animationRequestsByUrl = new Map<string, Promise<object | null>>();

const fetchAnimationData = async (contentManagerService: ContentManagerService, url: string) => {
  try {
    const content = await contentManagerService.getContent(url);

    if (isObject(content)) return content;
  } catch {
    // Dropped from the cache below so the next mount retries the request
  }

  animationRequestsByUrl.delete(url);
  return null;
};

export const loadAnimationData = (contentManagerService: ContentManagerService, url: string) => {
  const pendingRequest = animationRequestsByUrl.get(url);

  if (pendingRequest) return pendingRequest;

  const request = fetchAnimationData(contentManagerService, url);
  animationRequestsByUrl.set(url, request);

  return request;
};
